import styles from './AdminHomePage.module.css'

export function AdminHomePage() {
  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>Administração</h1>
        <p className={styles.subtitle}>Painel de controle administrativo</p>
      </div>
    </div>
  )
}
